import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { ToastManagerRepository } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticationResetPasswordUseCase {
    constructor(
        @inject(authenticationTypes.repositories.AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}

    async execute(
        token: string,
        password: string,
        password_confirmation: string,
    ): Promise<boolean> {
        const resetPasswordResult =
            await this.authenticationRepository.resetPassword(
                token,
                password,
                password_confirmation,
            );

        if (resetPasswordResult.isErr()) {
            ToastManagerRepository.error(resetPasswordResult.error.message);
            return false;
        }

        return true;
    }
}
